'use client'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'
import useSWR from 'swr'

import {
  getShippingAddresses,
  SHIPPING_ADDRESSES_SWR_KEY,
} from '@maestro/commerce-blocks/client/api/shipping-addresses'
import { SHIPPING_ADDRESS_SWITCHER_MODAL_KEY } from '@maestro/commerce-blocks/components/address-shipping-switcher/address-shipping-switcher.constants'
import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { createLogger } from '@maestro/core/logger'
import { EventType } from '@maestro/data-layer'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

const log = createLogger('maestro:commerce-blocks:shipping-address-switcher')

export const useTopbarAddressShippingSwitcher = () => {
  const { addOrUpdateHashParam } = useHash()
  const t = useTranslations('commerce-blocks.shipping-address-switcher')
  const { session } = useMaestroSession()
  const { publish } = useEventBusContext()

  const isUserLoggedIn = useMemo(() => {
    return !!session?.user?.id
  }, [session?.user?.id])

  const { data: addresses } = useSWR(
    isUserLoggedIn ? SHIPPING_ADDRESSES_SWR_KEY : null,
    getShippingAddresses,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
      onError: (error) =>
        log.error('Error fetching shipping addresses count:', error),
    }
  )

  const hasMultipleAddresses = (addresses?.length ?? 0) > 1

  const handleClickAddressShippingSwitcher = useCallback(() => {
    publish(EventType.SLIDE_IN_OPENED, {
      title: t('title'),
      slideInType: SHIPPING_ADDRESS_SWITCHER_MODAL_KEY,
      action: 'open',
    })
    addOrUpdateHashParam(SHIPPING_ADDRESS_SWITCHER_MODAL_KEY)
  }, [addOrUpdateHashParam, publish, t])

  return {
    handleClickAddressShippingSwitcher,
    isUserLoggedIn,
    hasMultipleAddresses,
  }
}
